import React from "react";
import PropTypes from "prop-types";
import styles from "./SectionElementBar.module.css";
import ShapeButton from "../ShapeButton";
import { FaCaretUp } from "react-icons/fa";
import { FaCaretDown } from "react-icons/fa";
import { IconContext } from "react-icons/lib";

/**
 * Interactive component. A bar that allows the user to rearrange or remove an item from a list.
 */
export function SectionElementBar({ position, onUp, onDown, onRemove }) {
  return (
    <>
      <div className={styles.container}>
        <button className={styles.caretUpDiv} style={{ fontSize: "20px" }}>
          {position === 1 ? (
            <>
              <IconContext.Provider value={{  }}>
                <FaCaretUp className={styles.iconOne} />
              </IconContext.Provider>
            </>
          ) : position === 2 || position === 3 ? (
            <>
              <IconContext.Provider
                value={{ style: {  } }}
              >
                <FaCaretUp className={styles.iconTwo} onClick={onUp} />
              </IconContext.Provider>
            </>
          ) : (
            <>
              <IconContext.Provider
                value={{ style: {  } }}
              >
                <FaCaretUp className={styles.iconOne} />
              </IconContext.Provider>
            </>
          )}
        </button>
        <button
          className={styles.roundBtnDiv}
          onClick={onRemove}
          style={{ fontSize: "12px" }}
        >
          <ShapeButton shape="round" className={styles.roundBtn} />
        </button>
        <button className={styles.caretDownDiv} style={{ fontSize: "20px" }}>
          {position === 1 || position === 2 ? (
            <>
              <IconContext.Provider
                value={{ style: { } }}
              >
                <FaCaretDown className={styles.iconTwo} onClick={onDown} />
              </IconContext.Provider>
            </>
          ) : (
            <>
              <IconContext.Provider
                value={{ style: {  } }}
              >
                <FaCaretDown className={styles.iconOne} />
              </IconContext.Provider>
            </>
          )}
        </button>
      </div>
    </>
  );
}

SectionElementBar.propTypes = {
  /**
   * The selected value.
   */
  position: PropTypes.number,
  /**
   * The selected value.
   */
  onUp: PropTypes.func,
  /**
   * The selected value.
   */
  onDown: PropTypes.func,
  /**
   * The selected value.
   */
  onRemove: PropTypes.func,
};
